(ns teamoesterreich.admin-mode.detail-filter.person-filter
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.helper :as h] ;;(h/event-value e)
            [teamoesterreich.admin-mode.static-data :as staticData]
            [teamoesterreich.util.log :as log]))




(defn wait-do [!waiting? !loaded? event-fn]
  (fn [e]
    (let [val (h/event-value e)]
      (js/console.log "wait or do" @!waiting?)
      (when @!waiting? (js/clearTimeout @!waiting?))
      (reset! !waiting?
              (js/setTimeout
                (fn []
                  (event-fn val)
                  (reset! !waiting? false)
                  (reset! !loaded? false))
                500)))))

(defn wait-do-select [!waiting? !loaded? event-fn]
  (fn [e]
    (let [val (h/event-value e)]
      (js/console.log "wait or do" val)
      (event-fn val)
      (reset! !waiting? false)
      (reset! !loaded? false))))



(defn person-block [!detail-search !waiting? !loaded?]
  [mui/grid
   {:item true
    :xs 12
    :style {:marginBottom "7px"}
    }

   [mui/paper
    [mui/grid
     {:container true
      :direction "row"
      :alignItems "flex-start"
      :justify "flex-start"
      :spacing 1
      :style {:padding "5px"}
      }
     [mui/grid
      {:item true
       :lg 2
       :md 6
       :sm 8
       :xs 12
       }
      [mui/text-field
       {:default-value (str (:filter-age @!detail-search))
        :label       "Alter von"
        :placeholder "suche..."
        :type "number"
        ;:class       (:text-field classes)
        :onChange   (wait-do-select !waiting? !loaded? (fn [val] (swap! !detail-search assoc :filter-age val)))
        :fullWidth true
        :multiline   false}]]
     [mui/grid
      {:item true
       :lg 2
       :md 6
       :sm 8
       :xs 12
       }
      [mui/text-field
       {:default-value (str (:filter-age-max @!detail-search))
        :label       "Alter bis"
        :placeholder "suche..."
        :type "number"
        ;:class       (:text-field classes)
        :onChange  (wait-do-select !waiting? !loaded? (fn [val] (swap! !detail-search assoc :filter-age-max val)))
        :fullWidth true
        :multiline   false}]]


     [mui/grid
      {:item true
       :lg 3
       :md 6
       :sm 8
       :xs 12
       }

      [mui/form-control
       {
        :fullWidth true
        }
       [mui/input-label "Staatsbürger"]
       [mui/select
        {:multiple true
         :value (or (get-in @!detail-search [:filter-nationality]) [])
         :onChange (wait-do-select !waiting? !loaded? (fn [val] (swap! !detail-search assoc :filter-nationality val)))
         }
        (for [[iso nat] staticData/NATIONALITIES]
          [mui/menu-item {:key (str "nat_" iso) :value iso } nat])
        ]]]
     [mui/grid
      {:item true
       :lg 3
       :md 6
       :sm 8
       :xs 12
       }

      [mui/form-control
       {
        :fullWidth true
        }
       [mui/input-label "Sprache"]
       [mui/select
        {:multiple true
         :value (or (get-in @!detail-search [:filter-language]) [])
         :onChange (wait-do-select !waiting? !loaded? (fn [val] (swap! !detail-search assoc :filter-language val)))
         }
        (for [[key val] staticData/LANGUAGES]
          [mui/menu-item {:key (str "lang_" key val) :value key } val])
        ]]]

     ]]])